import { Injectable } from '@angular/core';
import * as dayjs from 'dayjs';
import * as utc from 'dayjs/plugin/utc';
import * as timezone from 'dayjs/plugin/timezone';
import * as relativeTime from 'dayjs/plugin/relativeTime';
import * as calendar from 'dayjs/plugin/calendar';
import * as localizedFormat from 'dayjs/plugin/localizedFormat';
import * as customParseFormat from 'dayjs/plugin/customParseFormat';
import * as isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import 'dayjs/locale/ru';
import 'dayjs/locale/be';
import 'dayjs/locale/en';

@Injectable({
  providedIn: 'root',
})
export class DayjsConfigService {
  constructor() {
    this.initializeDayjs();
  }

  private initializeDayjs(): void {
    dayjs.extend(utc);
    dayjs.extend(timezone);
    dayjs.extend(relativeTime);
    dayjs.extend(calendar);
    dayjs.extend(localizedFormat);
    dayjs.extend(customParseFormat);
    dayjs.extend(isSameOrBefore);
  }
}
